/* eslint-disable no-unused-vars */
import axios from "../../axios";

const state = {
  lessons: [],
  totalRecords: 0,
  totalPages: 1,
  currentPage: 1,
  perPage: 10,
  isResetPage: false,
};

const actions = {
  /**
   * Get List lessons
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getAllLessons({ commit }, { query, isCommit = true }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/lessons?${new URLSearchParams(query)}`)
        .then((response) => {
          if (isCommit) {
            commit("SET_LESSONS", response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Create Lesson
   * @param commit
   * @param payload
   * @returns {Promise<*>}
   */
  async createLesson({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/lessons", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Update lesson
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async updateLesson({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/lessons/${id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete Lesson
   * @param commit
   * @param id
   * @returns {Promise<boolean>}
   */
  async deleteLesson({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/lessons/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Clone Lesson
   * @param commit
   * @param id
   * @returns {Promise<*>}
   */
  async cloneLesson({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/lessons/${id}/duplicate`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async transferLesson({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/lessons/${id}/transfer`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete Lesson
   * @param commit
   * @param payload
   * @returns {Promise<boolean>}
   */
  async changeLessonOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("/lessons/change-order", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },

  setTotalPages({ commit }, total) {
    commit("SET_TOTAL_PAGES", total);
  },

  updateLessons({ commit }, data) {
    commit("SET_LESSONS", data);
  },

  updateLessonSections({ commit }, sections) {
    commit("SET_LESSON_SECTIONS", sections);
  },

  updateLessonSection({ commit }, section) {
    commit("SET_LESSON_SECTION", section);
  },

  /**
   * Set reset page
   * @param {*} param0
   * @param {*} status
   */
  setStatusResetPage({ commit }, status) {
    commit("SET_RESET_PAGE", status);
  },
};

const mutations = {
  SET_LESSONS(state, data) {
    state.lessons = data;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_TOTAL_PAGES(state, total) {
    state.totalPages = total;
  },
  SET_LESSON_SECTIONS(state, sections) {
    if (sections.length) {
      let lessons = state.lessons;
      let lessonFindIdx = lessons.findIndex((item) => {
        return item.id === sections[0].lesson_id;
      });
      if (lessonFindIdx >= 0) {
        lessons[lessonFindIdx].sections = sections;
        state.lessons = lessons;
      }
    }
  },
  SET_LESSON_SECTION(state, section) {
    let lessons = state.lessons;
    let lessonFindIdx = lessons.findIndex((item) => {
      return item.id === section.lesson_id;
    });
    if (lessonFindIdx >= 0) {
      const findIndex = lessons[lessonFindIdx].sections.findIndex((item) => {
        return item.id === section.id;
      });
      if (findIndex >= 0) {
        //update
        lessons[lessonFindIdx].sections[findIndex] = section;
      } else {
        lessons[lessonFindIdx].sections.push(section);
      }
      state.lessons = lessons;
    }
  },
  SET_RESET_PAGE(state, status) {
    state.isResetPage = status;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
